// The native `accept` attribute only filters the OS file picker — it does
// nothing for drag-and-drop and most pickers still let a user override it
// with "All Files", so any upload surface (this component, or a plain
// <input> elsewhere that accepts files another way) must re-check with this
// to actually enforce the allow-list.
export function isAcceptedFileType(file: File, accept: string): boolean {
  const patterns = accept
    .split(',')
    .map((p) => p.trim().toLowerCase())
    .filter(Boolean);
  if (patterns.length === 0) return true;

  const name = file.name.toLowerCase();
  const type = file.type.toLowerCase();
  return patterns.some((pattern) => {
    if (pattern.startsWith('.')) return name.endsWith(pattern);
    if (pattern.endsWith('/*')) return type.startsWith(pattern.slice(0, -1));
    return type === pattern;
  });
}
